/**
 * Created by Jerker Nord on 2019-03-12.
 */

// imported this file from Thor Game for betline animations.

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {TombOfNefertitiAnimatedWinlinesView} from "./TombOfNefertitiAnimatedWinlinesView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TombOfNefertitiParsedInitData} from "../../server/data/TombOfNefertitiParsedInitData";

export class TombOfNefertitiAnimatedWinlineController extends BaseController {

    public static readonly PLAY_ANIMATED_WINLINE: string = "TombOfNefertitiAnimatedWinlinesView_playAnimatedWinline";
    public static readonly CLEAN_UP_ANIMATED_WINLINE: string = "TombOfNefertitiAnimatedWinlinesView_cleanUpAnimatedWinline";
    public static readonly PLAY_INDIVIDUAL_WINLINE: string = "TombOfNefertitiAnimatedWinlinesView_playIndividualWinline";

    private _view: TombOfNefertitiAnimatedWinlinesView;

    constructor() {
        super();
        this._view = new TombOfNefertitiAnimatedWinlinesView();
        this.addEventListeners();
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TombOfNefertitiAnimatedWinlineController.PLAY_ANIMATED_WINLINE, (event: GameEvent): void => this.playAnimatedWinline(event.params[0], event.params[1], false, false));
        EventHandler.addEventListener(this, TombOfNefertitiAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE, (): void => this.cleanUpAnimatedWinlines());
        EventHandler.addEventListener(this, TombOfNefertitiAnimatedWinlineController.PLAY_INDIVIDUAL_WINLINE, (event: GameEvent): void => this.playAnimatedWinline(event.params[0], event.params[1], event.params[2], true, event.params[4]));
    }

    private onInitDataParsed(data: TombOfNefertitiParsedInitData): void {
        this._view.betLinesData = data.betLines;
    }

    private playAnimatedWinline(winLine: number, isStaticOrIsIdle: boolean, canIndividualLoop: boolean = false, isCalledFromIndividual: boolean, isCalledFromFSIntro?: boolean): void {
        this._view.getWinlineTL(winLine, isStaticOrIsIdle, canIndividualLoop, isCalledFromIndividual, isCalledFromFSIntro).play();
    }

    private cleanUpAnimatedWinlines(): void {
        this._view.getCleanUpWinlinesTL().play();
    }
}